const total = document.querySelector("#total-price");
const totalPrice = total.querySelector(".total__price");
const inputs = document.querySelectorAll(".calc__input input");
const products = document.querySelector("[data-id='products']");
const orders = document.querySelector("[data-id='orders']");
const items = document.querySelectorAll("li.list__item");

// create error messages for products and orders

const errorMessages = [];
for (let i = 0; i < 2; i++) {
    errorMessages[i] = document.createElement("p");
    errorMessages[i].classList.add("list__item");
    errorMessages[i].style.position = "absolute";
    errorMessages[i].style.width = "100%";
    errorMessages[i].style.height = "100%";
    errorMessages[i].style.top = "0";
    errorMessages[i].style.left = "0";
    errorMessages[i].style.backgroundColor = "#fb3b64";
    errorMessages[i].style.justifyContent = "center";
}
const [errorMessage1, errorMessage2] = errorMessages;
errorMessage1.innerText = "Value of products should be greater than 0.";
errorMessage2.innerText = "Value of orders should be greater than 0.";

products.style.position = "relative";
orders.style.position = "relative";
products.appendChild(errorMessage1);
orders.appendChild(errorMessage2);

// total 

const changeTotal = () => {
    total.classList.add("open");
    let sum = 0;
    items.forEach(item => {
        if (item.classList.contains("open") && !item.classList.contains("error")) {
            sum += parseFloat(item.querySelector(".item__price").innerText.replace(/[^0-9.-]+/g, ""));
        }
    });
    totalPrice.innerText = `$${sum}`;
}

document.querySelector("form").addEventListener("click", changeTotal);
document.querySelector("form").addEventListener("keyup", changeTotal);

// first 2 inputs

const calcItems = (e, el, errorM, price) => {
    el.classList.remove("open", "error");
    errorM.classList.remove("open");
    let n = e.currentTarget.value;

    if (n < 0 || n === "0") {
        el.classList.add("open", "error");
        errorM.classList.add("open");

    } else if (n > 0) {
        el.classList.add("open");
        el.querySelector(".item__calc").innerText = `${n} * $${price}`;
        el.querySelector(".item__price").innerText = `$${n * price}`;
    }
}

inputs[0].addEventListener("click", e => calcItems(e, products, errorMessage1, 10));
inputs[0].addEventListener("keyup", e => calcItems(e, products, errorMessage1, 10));
inputs[1].addEventListener("click", e => calcItems(e, orders, errorMessage2, 5));
inputs[1].addEventListener("keyup", e => calcItems(e, orders, errorMessage2, 5));

// select menu

const select = document.querySelector("#package");
const selectInput = document.querySelector(".select__input");
const selectDropdown = document.querySelector(".select__dropdown");
const package = document.querySelector("[data-id='package']");

const showPackage = (type, price) => {
    selectInput.innerText = type;
    selectInput.style.color = "black";
    package.querySelector(".item__calc").innerText = type;
    package.querySelector(".item__price").innerText = `$${price}`;
    package.classList.add("open");
}

selectInput.addEventListener("click", () => select.classList.toggle("open"));

document.querySelector("body").addEventListener("click", e => {
    if (e.target !== selectDropdown && e.target !== selectInput && select.classList.contains("open")) {
        select.classList.remove("open");
    }
});

selectDropdown.addEventListener("click", e => {
    select.classList.remove("open");
    if (e.target === selectDropdown.querySelector("[data-value='basic']")) {
        showPackage("Basic", 20);
    }
    else if (e.target === selectDropdown.querySelector("[data-value='professional']")) {
        showPackage("Professional", 30);
    }
    else if (e.target === selectDropdown.querySelector("[data-value='premium']")) {
        showPackage("Premium", 50);
    }
});

// checkboxes

const check1 = document.querySelector("#accounting");
const check2 = document.querySelector("#terminal");
const accounting = document.querySelector("[data-id='accounting']");
const terminal = document.querySelector("[data-id='terminal']");

check1.addEventListener("click", () => {
    (check1.checked) ? accounting.classList.add("open") : accounting.classList.remove("open");
});

check2.addEventListener("click", () => {
    (check2.checked) ? terminal.classList.add("open") : terminal.classList.remove("open");
});
